import { SET_ORDERS_STATISTICS, SET_TOP_CLIENTS, SET_STATISTICS_ALLDAY} from "./types"

const initialState = {
    orders_statistics: {
        allOrders: [],
        profit: []
    },
    top_clients: {
        allClients: [],
        numberOfRentedCarsOfClient: []
    },
    statistics_for_all_period: {
        date: [],
        profitForDay: [],
        orderForDay: []
    }
}

export const analyticsReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_ORDERS_STATISTICS:
            return {...state, orders_statistics: {
                    allOrders: action.payload.map(item => {
                        return item.brand
                    }),
                    profit: action.payload.map(item => {
                        return item.profit
                    })
                }}
        case SET_TOP_CLIENTS:
            return {...state, top_clients: {
                    allClients: action.payload.filter(user => user.orders_list > 0).map(topClient => {
                        return `${topClient.firstname} ${topClient.lastname}`
                    }),
                    numberOfRentedCarsOfClient: action.payload.map(topClient => {
                        return topClient.orders_list.length
                    })
                }}

        case SET_STATISTICS_ALLDAY:
            return {...state, statistics_for_all_period: {
                    date: action.payload.map(order => {
                        return Object.keys(order)
                    }),
                    profitForDay: action.payload
                }}
        default:
            return state
    }
}